module.exports = __webpack_public_path__ + "img/front_3.2db57f6d.svg";